"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    createJobOffer: {
        url: "/jobs",
        method: "POST",
    },
    jobsAvailable: {
        url: "/jobs/available",
        method: "GET",
    },
    myJobs: {
        url: "/me/jobs",
        method: "GET",
    },
    myApplications: {
        url: "/me/applications",
        method: "GET",
    },
    jobStats: {
        url: "/jobs/{id}/stats",
        method: "GET",
    },
    jobAction: {
        url: "/jobs/{id}/{action}",
        method: "PUT",
    },
};
//# sourceMappingURL=jobs.js.map